"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingPlan = void 0;
var date_fns_1 = require("date-fns");
var enums_1 = require("./enums");
var BillingPlanProperties = ['id', 'order', 'details', 'price_tier_id', 'priceTier', 'period', 'is_default', 'is_visible', 'status'];
/** @deprecated use Plan from ./interfaces/plan.ts */
var BillingPlan = /** @class */function () {
  function BillingPlan(values) {
    if (values === void 0) {
      values = {};
    }
    var properties = BillingPlanProperties;
    var instance = this;
    properties.forEach(function (p) {
      if (p in values) {
        instance[p] = values[p];
      }
    });
  }
  BillingPlan.prototype.getNextPaymentDate = function (date) {
    if (date === void 0) {
      date = new Date();
    }
    switch (this.period) {
      case enums_1.PlanPeriodEnum.day:
        return (0, date_fns_1.addDays)(date, 1);
        break;
      case enums_1.PlanPeriodEnum.day2:
        return (0, date_fns_1.addDays)(date, 2);
        break;
      case enums_1.PlanPeriodEnum.month1:
        return (0, date_fns_1.addMonths)(date, 1);
        break;
      case enums_1.PlanPeriodEnum.month3:
        return (0, date_fns_1.addMonths)(date, 3);
        break;
      case enums_1.PlanPeriodEnum.month6:
        return (0, date_fns_1.addMonths)(date, 6);
        break;
      case enums_1.PlanPeriodEnum.year:
        return (0, date_fns_1.addYears)(date, 1);
        break;
      case enums_1.PlanPeriodEnum.minutes30:
        return (0, date_fns_1.addMinutes)(date, 30);
        break;
    }
  };
  return BillingPlan;
}();
exports.BillingPlan = BillingPlan;
